import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import SCUIGenericExcelUpload from '../../../atomic/molecules/SCUIGenericExcelUpload/SCUIGenericExcelUpload';
import { FDCM } from '../fastDeliveryCargoManagement.classes';

interface BulkUploadTabProps {
    onUpload: (file: File) => void;
    loading?: boolean;
}

export const BulkUploadTab: FC<BulkUploadTabProps> = ({ onUpload, loading }) => {
    const { t } = useTranslation();

    const exampleData = [
        {
            'cargoCompanyId': "Hepsijet",
            'city': "İstanbul",
            'district': "Kadıköy",
            'neighborhood': "Caferağa",
            'isActiveForTodayDelivery': 1,
            'isActiveForTomorrowDelivery': 1,
            'isActiveForFastDelivery': 0
        }
    ];

    return (
        <SCUIGenericExcelUpload
            onUpload={onUpload}
            //title={t('fastDeliveryCargoManagement.bulkUploadTitle')}
            //description={t('fastDeliveryCargoManagement.bulkUploadDescription')}
            uploadButtonText={t('fastDeliveryCargoManagement.upload')}
            selectFileButtonText={t('fastDeliveryCargoManagement.selectExcelFile')}
            showExample={true}
            exampleData={exampleData}
            exampleButtonText={t('general.exampleExcel')}
            loading={loading}
            className={FDCM.bulkUploadSection}
            exampleWrapClassName={FDCM.bulkUploadExampleWrap}
            dropzoneClassName={FDCM.bulkUploadDropzone}
            fileInputClassName={FDCM.inputFileExcel}
            selectFileButtonClassName={FDCM.inputButtonSelectExcelFile}
            uploadButtonClassName={FDCM.inputButtonUploadExcel}
        />
    );
};

export default BulkUploadTab; 